import {Component, ViewChild} from '@angular/core';
import {MenuController, NavController, Platform, ToastController} from 'ionic-angular';
import {TabsPage} from '../pages/tabs/tabs';
import {UserService} from "./services/user.service";
import {HTTP} from "@ionic-native/http";
import {CUSTOMER_DATA_STORAGE} from "./constants/storage";
import {StorageService} from './services/storage.service';
import {SplashScreen} from "@capacitor/splash-screen";

@Component({
  templateUrl: 'app.html',
  providers: [UserService]
})
export class MyApp {
  @ViewChild('rootNav') navCtrl: NavController;
  rootPage = TabsPage;

  public backButtonSub;
  public lastTimeBackPress = 0;
  public timePeriodToExit = 3000;

  constructor(private http: HTTP, private storage: StorageService,
              private platform: Platform,
              private toastCtrl: ToastController,
              private menuCtrl: MenuController) {
    platform.ready().then(() => {
      SplashScreen.hide()
    });

    this.backButtonEvent();
  }



  backButtonEvent() {
    this.platform.registerBackButtonAction(async () => {
      const openMenu = await this.menuCtrl.getOpen();
      if (openMenu) {
        await openMenu.close();
        return;
      }

      await this.navCtrl.popToRoot(); // IF IT'S NOT THE ROOT, POP A PAGE.

      //Double check to exit app
      if (new Date().getTime() - this.lastTimeBackPress < this.timePeriodToExit) {
        this.platform.exitApp(); //Exit from app
      } else {
        let toast = this.toastCtrl.create({
          message: 'Noch einmal drücken um die App zu beenden.',
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
        this.lastTimeBackPress = new Date().getTime();
        return;
      }
    });
  }

  initCustomer(customerPayload) {
    this.storage.set(CUSTOMER_DATA_STORAGE, customerPayload);
  }

  handleError(err: any) {

  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts